import { getIsApplicantClosed } from '../../RentalPortalApplicantProfile.utils'

export function getCanEditApplicantNote({ applicantData, isPreview }) {
  return Boolean(
    !isPreview &&
    !getIsApplicantClosed(applicantData) &&
    applicantData?.permissions?.can_edit_content
  )
}
